import { isDemoMode } from './runtimeMode';

const parseEmailList = (value) => String(value || '')
  .split(',')
  .map((email) => email.trim().toLowerCase())
  .filter(Boolean);

const DEMO_ALL_MODULE_ACCESS_EMAILS = new Set([
  '3p3cao@gmail.com',
  'ctdemo.cao@proton.me'
]);

const EXPLICIT_FIRE_ACCESS_EMAILS = new Set([
  'nickh@diamondvalley.town',
  ...parseEmailList(process.env.REACT_APP_FIRE_ACCESS_OVERRIDE_EMAILS)
]);

const ALL_MODULE_ACCESS_EMAILS = new Set([
  'nickh@diamondvalley.town',
  'doreen@davg.ca',
  'sy1951901albertaltd@shaw.ca',
  'safety@diamondvalley.town',
  'contact@3p3.ca',
  'trevord@diamondvalley.town',
  'firechief@diamondvalley.town',
  'logans@diamondvalley.town',
  'cao@diamondvalley.town',
  ...parseEmailList(process.env.REACT_APP_ALL_MODULE_ACCESS_OVERRIDE_EMAILS)
]);

const FLHA_FIRST_LANDING_EMAILS = new Set([
  'firechief@diamondvalley.town',
  'logans@diamondvalley.town',
  'trevord@diamondvalley.town',
  ...parseEmailList(process.env.REACT_APP_FLHA_FIRST_LANDING_EMAILS)
]);

export const hasExplicitFireAccessEmail = (email) => EXPLICIT_FIRE_ACCESS_EMAILS.has(String(email || '').trim().toLowerCase());

export const hasAllModuleAccessEmail = (email) => {
  const normalizedEmail = String(email || '').trim().toLowerCase();
  return ALL_MODULE_ACCESS_EMAILS.has(normalizedEmail)
    || (isDemoMode() && DEMO_ALL_MODULE_ACCESS_EMAILS.has(normalizedEmail));
};

export const hasFlhaFirstLandingEmail = (email) => FLHA_FIRST_LANDING_EMAILS.has(String(email || '').trim().toLowerCase());

export const getExplicitFireAccessEmails = () => [...EXPLICIT_FIRE_ACCESS_EMAILS];

export const getAllModuleAccessEmails = () => [
  ...ALL_MODULE_ACCESS_EMAILS,
  ...(isDemoMode() ? [...DEMO_ALL_MODULE_ACCESS_EMAILS] : [])
];

export const getFlhaFirstLandingEmails = () => [...FLHA_FIRST_LANDING_EMAILS];
